import { render, staticRenderFns } from "./ItemPaymentDetail.vue?vue&type=template&id=1a10533d"
import script from "./ItemPaymentDetail.vue?vue&type=script&lang=js"
export * from "./ItemPaymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports